const Layout1Settings = {
    leftSidebar: {
        show: true,
        mode: 'full', // full, close, compact, mobile,
        theme: 'blue', // View all valid theme colors inside MatxTheme/themeColors.js
        //theme: 'whiteGray', // View all valid theme colors inside MatxTheme/themeColors.js

        bgImgURL: '/assets/images/sidebar/bg.jpg',
       // bgImgURL: 'none',

    },
    topbar: {
        show: true,
        fixed: true,
        //theme: 'whiteBlueNav', // View all valid theme colors inside MatxTheme/themeColors.js
        theme: 'blue', // View all valid theme colors inside MatxTheme/themeColors.js
    },
}

export default Layout1Settings
